/* DISABLED — Releasit manual ZIP coverage handler
 * Replaced by SereniVida-style CODCoverageData + cod-coverage-validator.js + XHR guard.
 * Kept as inert file so old layout references (if any) do nothing.
 */
(function () {
  'use strict';
  try { console.info('[coverage] releasitZipCodePaymentHandler disabled; using metafield validator'); } catch (e) {}
})();